import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import ProductsView from "./ProductsView";
import BaseAdminView from "./BaseAdminView";
// import CommerceUserView from "./CommerceUserView";
import StagesManager from "../../components/StagesManager";
import Cookies from "universal-cookie";
import { chooseFontColor, conditionalWidth } from "../../utils/useful";
// import ViewBlog from "./database/ViewBlog";
// import DatabaseAdminView from "./database/DatabaseAdminView";
// import HttpServices from "../../utils/Http.services";
import BookingUserView from "./BookingUserView";
import { BookingPages } from "../../variables/AppletPages";
import CollectionBaseUserView from "./CollectionBaseUserView";
import { framesConfig } from "../../variables/framesStatics";
// import BookingAdminView from "./booking/BookingAdminView";


class BookingApplet extends React.Component {
    state = {
        colors: {
            primaryColor: '#94257c',
            secondaryColor: '#771462',
            textColor: '#fff'
        }
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'BookingApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    componentDidMount() {

        // console.log("componentDidMount C")

        // const cookies = new Cookies();
        // let token = cookies.get('token');
        // if (token) {
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        // } else {
        //     this.setState({ pageStatus: 401 })
        // }



        // let frames = Object.values(BookingPages.pages)
        // let framesSections = Object.values(BookingPages.sections)

        // this.setState({ frames, framesSections }, () => {
        this.waitForId(10)
        // })

        this.init()

        // let data = {}
        // data.applet = this.props.applet


        // let frames = Object.values(CommercePages.pages)
        // let framesSections = Object.values(CommercePages.sections)


        // HttpServices.request('getFrames', data, (fetchResult, fetchError) => {

        //     if (fetchError) {
        //         return
        //     }
        //     let frames = fetchResult.info
        //     let framesSections = [
        //         { key: 'collections', name: '{{lang}}Collections', addNew: true, icon: '/images/applets-icons/accounting/063-cart.svg' },
        //         { key: 'pages', name: '{{lang}}Pages', addNew: true, icon: '/images/applets-icons/accounting/063-cart.svg' },
        //     ]

        //     if (Array.isArray(frames)) {
        //         frames.forEach(element => {
        //             element.key = element._id
        //             element.section = 'collections'
        //             element.pageType = 'collection'
        //             element.fetchUrl = 'getRecords'
        //             element.addUrl = 'postRecord'
        //             element.editUrl = 'postRecord'
        //             element.removeUrl = 'removeRecord'
        //             element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        //             element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
        //             element.fields.forEach(field => {
        //                 field.key = "values." + field.key
        //             });
        //         });
        //     }

        //     console.log("frames, ", frames)

        //     this.setState({ frames, framesSections, currentFrameName: fetchResult.info[0].name })
        // })

    }


    waitForId = (leftAttempt) => {
        // if (this.props.user?.info?._id) {

        this.checkDefaultTab()
        // } else {
        //     setTimeout(() => {
        //         if (leftAttempt != 0) {
        //             this.waitForId(leftAttempt - 1)
        //         } else {
        //             // this.props.actions.logoutUser()
        //             this.setState({ pageStatus: 401 })
        //         }
        //     }, 500);
        // }
    }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        // console.log('commeerceeeeee', prevProps, this.props.windowData, this.props.lastSelected);
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('commeerceeeeee');
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }

        if ((JSON.stringify(this.props.frames) != JSON.stringify(prevProps.frames))) {
            this.init()
        }
    }




    init = () => {



        let frames = this.props.frames



        // this.setState({ frames, framesSections }, () => {
        //     this.waitForId(10)
        // })

        // console.log("frames",this.props.applet,frames)
        // let framesSections = [
        //     { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
        //     { key: 'pages', name: '{{lang}}Pages', addNew: 'addPage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // ]

        if (Array.isArray(frames)) {
            // console.log('this.props.framessl',this.props.frames)
            frames.forEach(element => {
                let frameInfo
                // console.log('element0000',element)
                if (element.mode) {
                    frameInfo = framesConfig[element.mode]
                }
                if (!frameInfo) {
                    frameInfo = framesConfig[element.type]
                }

                if (frameInfo) {
                    Object.entries(frameInfo)?.map(([key, value]) => {
                        element[key] = value
                        if (typeof value == 'string' && value.startsWith('{{')) {
                            let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                            element[key] = element[baseValue]
                        }
                    })
                }

                if (element.type == 'collection' && Array.isArray(element.fields)) {
                    element.fields.forEach(field => {
                        // if (!field.key.includes("values.")) {
                        //     field.key = "values." + field.key
                        // }
                    })
                }
                // if (element.type == 'collection') {
                //     element.key = element._id
                //     element.section = 'collections'
                //     element.pageType = 'collection'
                //     element.fetchUrl = 'getRecords'
                //     element.addUrl = 'postRecord'
                //     element.editUrl = 'updateRecord'
                //     element.removeUrl = 'removeRecord'
                //     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                //     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }

                // }

                // else if (element.type == 'page') {
                //     element.key = element._id
                //     element.section = 'pages'
                //     element.pageType = 'page'
                //     element.fetchUrl = 'getRecords'
                //     element.addUrl = 'postRecord'
                //     element.editUrl = 'postRecord'
                //     element.removeUrl = 'removeRecord'
                //     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                //     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                //     element.fields.forEach(field => {
                //         if (!field.key.includes("values.")) {
                //             field.key = "values." + field.key
                //         }
                //     })
                // }
            })
        }

        // let defFrames = Object.values(BookingPages.pages)
        // let framesSections = Object.values(BookingPages.sections)


        // frames = frames.concat(defFrames)

        // console.log("frames, ", frames)
        // console.log('frammeesss',frames)

        let currentFrameName = frames ? frames[0]?.name : null
        this.setState({ frames, currentFrameName })


    }

    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            // console.log('page', pageType, def);
            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }




    render() {


        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`


        return (

            <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                    <BaseAdminView stageName={'admin'} showSettings={"bookingApplet"} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />

                    <CollectionBaseUserView userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables}
                        colors={colors} frames={this.state.frames} framesSections={this.state.framesSections}
                        changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} />
                    {/* <BookingUserView stageName={''} baseUrl={[...this.props.baseUrl]} language={this.props.language} colors={colors} removeWindowLink={this.props.removeWindowLink} width={this.props.width} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} goToHub={this.props.goToHub} /> */}
                    {/* <BookingAdminView stageName={''} baseUrl={[...this.props.baseUrl]} language={this.props.language} colors={colors}  removeWindowLink={this.props.removeWindowLink} width={this.props.width} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} goToHub={this.props.goToHub} /> */}

                </StagesManager>

            </div>
        )
    }



}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BookingApplet);
